export default class UrlToActivityMapping{
    constructor(){
        /** @type {string} */
        this.key = '';
        /** @type {*} */
        this.activityClass = null;
        /** @type {string[]} */
        this.exposedProps = [];
    }
}
